import {memo, useEffect, useRef} from 'react'
import {useTranslation} from 'react-i18next'
import {useSWRConfig} from 'swr'

import {userDisconnectedEventName} from '../enums/event'
import {useNotification} from '../hooks/useNotification'
import {useUserIdentifier} from '../states/auth'
import eventDispatcher from '../utils/eventDispatcher'
import {createCollectionIri} from '../utils/iri'

const AuthNotification = memo(function AuthNotification() {
  const {notifyInfo} = useNotification()
  const {t} = useTranslation()

  useEffect(() => {
    const controller = new AbortController()
    eventDispatcher.addEventListener(userDisconnectedEventName, () => {
      notifyInfo(t('error.http.logout'))
    }, {signal: controller.signal})

    return () => {
      controller.abort()
    }
  }, [notifyInfo, t])

  return null
})

const AuthCrossTabSync = memo(function AuthCrossTabSync() {
  const userIdentifier = useUserIdentifier()
  const prevRef = useRef(userIdentifier)
  const {mutate} = useSWRConfig()

  useEffect(() => {
    if (prevRef.current === userIdentifier) {
      return
    }
    prevRef.current = userIdentifier

    void mutate(createCollectionIri('me'))
  }, [userIdentifier, mutate])

  return null
})

export const AuthListener = memo(function AuthListener() {
  return <>
    <AuthNotification/>
    <AuthCrossTabSync/>
  </>
})
